import { check } from "valibot";
import { GoogleAnalyticsEvent, GoogleEventAction } from "./events.enum";
import { trackGAEvent } from "./trackEvent";

export const GoogleAnalytics = {

    /* ===================== GENERIC ======================= */

    pageView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PAGE_VIEW, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    scroll(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PAGE_SCROLL, {
            action: GoogleEventAction.SCROLL,
            ...payload
        });
    },

    cta(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.CTA_CLICK, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },
    component_event(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.COMPONENT_EVENT, {
            ...payload
        });
    },

    popupClose(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.POP_UP_CLOSE, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    componentClick(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.COMPONENT_CLICK, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    backButtonClick(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.BACK_BUTTON_EVENT, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    componentImpression(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.COMPONENT_IMPRESSION, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    toast(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.TOAST_SHOW, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    errorPopupShow(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ERROR_POPUP_SHOW, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    /* ====================== Location ======================= */

    selectLocationScreen(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SELECT_LOCATION_SCREEN, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    locationChangeConfirmationPopup(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.LOCATION_CHANGE_CONFIRMATION_POPUP, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    /* ====================== SEARCH ======================= */

    searchOpen(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SEARCH_OPEN, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    search(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SEARCH, payload);
    },

    searchPerformed(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SEARCH_PERFORMED, payload);
    },

    searchSuggestionClicked(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SEARCH_SUGGESTION_CLICKED, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    viewSearchResults(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.VIEW_SEARCH_RESULTS, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    /* ===================== PAGES ========================= */

    pdpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PDP_VIEW, payload);
    },

    plpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PLP_VIEW, payload);
    },

    clpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.CLP_VIEW, payload);
    },

    slpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.SLP_VIEW, payload);
    },

    /* ====================== CART ========================= */

    addToCart(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ADD_TO_CART, payload);
    },

    removeFromCart(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.REMOVE_FROM_CART, payload);
    },

    viewCart(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.VIEW_CART, payload);
    },

    beginCheckout(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.BEGIN_CHECKOUT, payload);
    },

    cartApiCall(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.CART_API_CALL, {
            action: GoogleEventAction.API_CALL,
            ...payload
        });
    },

    /* ===================== PAYMENT ======================= */

    paymentFailed(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PAYMENT_FAILED, payload);
    },

    paymentCancelled(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PAYMENT_CANCELLED, payload);
    },

    paymentSuccess(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PAYMENT_SUCCESS, payload);
    },

    /* ===================== ORDER ========================= */

    purchase(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.PURCHASE, payload);
    },

    orderFailed(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ORDER_FAILED, payload);
    },

    orderConfirmed(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ORDER_CONFIRMED, payload);
    },

    orderUnknown(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ORDER_UNKNOWN, payload);
    },

    orderPending(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ORDER_PENDING, payload);
    },

    /* ===================== ORDER ========================= */

    ratingPopUpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.RATING_POPUP_VIEW, { action: GoogleEventAction.VIEW, ...payload });
    },

    loginEvent(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.LOGIN_EVENT, {
            ...payload
        });
    },

    /* ===================== POP UP VIEW ========================= */

    popUpView(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.POP_UP_VIEW, {
            action: GoogleEventAction.VIEW,
            ...payload
        });
    },

    popUpClick(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.POP_UP_CLICK, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    popUpClose(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.POP_UP_CLOSE, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    igmUploadEvent(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.IGM_UPLOAD, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    igmUploadError(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.IGM_UPLOAD_ERROR, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    igmUploadErrorCount(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.IGM_UPLOAD_ERROR_COUNT, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    igmUploadSuccess(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.IGM_UPLOAD_SUCCESS, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    igmRemoveUpload(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.IGM_REMOVE_UPLOAD, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    /* ===================== LOCATION AND ADDRESS ======================= */


    address(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.ADDRESS, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    locationEvent(payload: any = {}) {
        trackGAEvent(GoogleAnalyticsEvent.LOCATION, {
            action: GoogleEventAction.CLICK,
            ...payload
        });
    },

    getClientID() {
        const match = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/);
        return match ? match[1] : null;
    }
};
